// src/components/ui/0-atoms/ShowMoreButton/ShowMoreButton.js

import React from 'react';
import styles from './ShowMoreButton.module.css';

/**
 * A text-style button component for expanding/collapsing content
 * @param {boolean} isExpanded - Current expansion state
 * @param {function} onClick - Click handler
 * @param {string} [expandText] - Text to show when collapsed (default: "Show more")
 * @param {string} [collapseText] - Text to show when expanded (default: "Show less")
 * @param {string} [className] - Additional CSS classes
 */
const ShowMoreButton = ({ 
  isExpanded, 
  onClick, 
  expandText = 'Show more',
  collapseText = 'Show less',
  className = ''
}) => {
  return (
    <button 
      className={`${styles.button} ${className}`}
      onClick={onClick}
      aria-expanded={isExpanded}
      aria-label={isExpanded ? collapseText : expandText}
      type="button"
    >
      <span className={styles.text}>
        {isExpanded ? collapseText : expandText}
      </span>
      <svg 
        className={`${styles.arrow} ${isExpanded ? styles.arrowUp : ''}`}
        width="12" 
        height="12" 
        viewBox="0 0 12 12" 
        fill="none"
        aria-hidden="true"
      >
        <path 
          d="M3 4.5L6 7.5L9 4.5" 
          stroke="currentColor" 
          strokeWidth="1.5" 
          strokeLinecap="round" 
          strokeLinejoin="round"
        />
      </svg>
    </button>
  );
};

export default ShowMoreButton;